import PropTypes from "prop-types";
import { useState } from "react";
import { resolveImage } from "../cart-redesign/pricing";

/* First letters of the product name, used when no catalogue image resolves. */
const initials = (name) =>
  String(name || "?")
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join("");

/*
 * Some catalogue entries carry an image path the backend no longer serves,
 * so a broken load falls back to the initials tile rather than an empty box.
 */
const Thumb = ({ image, name }) => {
  const [broken, setBroken] = useState(false);
  const src = image ? resolveImage(image) : "";

  return (
    <span className="c4trk__thumb">
      {src && !broken ? (
        <img src={src} alt="" loading="lazy" onError={() => setBroken(true)} />
      ) : (
        <span className="c4trk__thumb-fallback" aria-hidden="true">
          {initials(name)}
        </span>
      )}
    </span>
  );
};

Thumb.propTypes = {
  image: PropTypes.string,
  name: PropTypes.string,
};

const ShipmentItems = ({ lines, formatPrice }) => (
  <section className="c4trk__card" aria-labelledby="c4trk-items-heading">
    <h2 className="c4trk__card-title" id="c4trk-items-heading">
      Items In This Shipment ({lines.length})
    </h2>

    <ul className="c4trk__items">
      {lines.map((line) => (
        <li className="c4trk__item" key={line.key}>
          <Thumb image={line.image} name={line.name} />

          <span className="c4trk__item-info">
            <span className="c4trk__item-name">{line.name}</span>
            <span className="c4trk__item-qty">Qty {line.quantity}</span>
          </span>

          <span className="c4trk__item-price">
            {line.lineTotal != null ? formatPrice(line.lineTotal) : "—"}
          </span>
        </li>
      ))}
    </ul>
  </section>
);

ShipmentItems.propTypes = {
  lines: PropTypes.array.isRequired,
  formatPrice: PropTypes.func.isRequired,
};

export default ShipmentItems;
